// src/redux/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import rootReducer from "./rootReducer";
import { persistedReduxKeys } from "./persistConfig";

const localStorageKeysToClear = [
  "otp_access_token",
  "resumeSessionData",
  "persistentPersonal",
  "persistentTravel",
  "persistentQuote",
  "coverageApiData",
  "coverageOptionsWithIds",
  "travel_step1_details",
  "travel_step2_details",
  "docUploadCurrentStep",
  "docUploadMoreInfo",
  "selectedCar",
  "selectedVehicleVariant",
];

// Persist configuration
// UI slice is excluded because popup/modal state should not survive page refresh.
const persistConfig = {
  key: "root",
  storage,
  whitelist: [""],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: import.meta.env.DEV,
});

// Redux Persist
export const persistor = persistStore(store);

export const clearAllReduxData = async () => {
  persistor.pause();

  store.dispatch({ type: "CLEAR_ALL_REDUX_DATA" });

  await persistor.purge();

  localStorageKeysToClear.forEach((key) => localStorage.removeItem(key));

  await persistor.flush();
  window.location.replace("/login");
};
// Types
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
